function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.6395 11.3259C19.5221 8.19497 14.4568 8.18404 11.3258 11.3015C8.19489 14.4189 8.18395 19.4842 11.3014 22.6152C14.4188 25.7461 19.4841 25.757 22.6151 22.6396C25.746 19.5221 25.7569 14.4568 22.6395 11.3259ZM9.91466 9.88422C13.8283 5.98741 20.16 6.00108 24.0568 9.91474C27.9536 13.8284 27.9399 20.16 24.0262 24.0568C20.1126 27.9537 13.7809 27.94 9.88414 24.0263C5.98733 20.1127 6.001 13.781 9.91466 9.88422ZM16.9833 11.0208C17.5356 11.022 17.9823 11.4707 17.9811 12.023L17.9726 15.9727L21.9223 15.9812C22.4746 15.9824 22.9214 16.4311 22.9202 16.9834C22.919 17.5357 22.4703 17.9824 21.918 17.9812L17.9683 17.9727L17.9598 21.9224C17.9586 22.4747 17.5099 22.9215 16.9576 22.9203C16.4053 22.9191 15.9586 22.4704 15.9598 21.9181L15.9683 17.9684L12.0186 17.9598C11.4663 17.9587 11.0195 17.51 11.0207 16.9577C11.0219 16.4054 11.4706 15.9587 12.0229 15.9599L15.9726 15.9684L15.9811 12.0186C15.9823 11.4664 16.431 11.0196 16.9833 11.0208Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(17.0071) rotate(45.1237)"
})));

function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.ddee4063.svg";
export { ForwardRef as ReactComponent };